/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import { Section, MultiSelectDropdown } from '@heronhr/trivia-games';
import { PlanCardTooltip } from 'components/Tooltip';
import { ReactComponent as InfoIcon } from 'assets/images/home/infoIcon.svg';
import popular from 'assets/images/billing/popular.svg';
import MantineModal from 'components/Modal/MantineModal';
import TextField from 'components/TextField';
import styles from '../styles.module.scss';

const PlanCardComponent = ({
  index,
  btnPlan,
  handleButtonClick,
  isCalculatingUniqueUsersCount,
  handleClickInChannelDropdown,
  username,
  useremail,
  dropDownChannelOptions,
  selectedChannels,
  open,
  setOpen,
  billingInfo,
  setBillingInfo,
  handleStripeRedirect,
  data,
  platform,
  selectedchannelLength,
  billingIntervalState,
  plans,
  freeTrial,
  activeUsers,
  uniqueUsersCount,
  channelBasedBilling
}) => {
  const term = plans?.TERM || 'month';
  const discountPercentage = 0.2;
  const usersCount = channelBasedBilling ? uniqueUsersCount : activeUsers;
  const roundOffNumber = (num) => Math.round(num * 100) / 100;

  // Method to calculate yearly/monthly price along with discounted values
  const calculateCosts = (cost) => {
    const isYearly = term === 'year';
    if (isYearly) {
      const costWithoutDiscount = Math.round(cost / (1 - discountPercentage));
      const monthlyCost = Math.round((cost + discountPercentage) / 12);
      const totalCostWithoutDiscount = costWithoutDiscount * usersCount;
      const totalMonthlyCost = monthlyCost * usersCount;
      const costWithDiscount = cost * (1 - discountPercentage);
      const totalCostWithDiscount = Math.round(costWithDiscount * usersCount);
      return {
        monthlyCost: roundOffNumber(monthlyCost),
        costWithoutDiscount: roundOffNumber(costWithoutDiscount),
        totalMonthlyCost: roundOffNumber(totalMonthlyCost),
        totalCostWithoutDiscount: roundOffNumber(totalCostWithoutDiscount),
        costWithDiscount: roundOffNumber(costWithDiscount),
        totalCostWithDiscount: roundOffNumber(totalCostWithDiscount)
      };
    }
    const yearlyCost = cost * 12;
    const totalYearlyCost = yearlyCost * usersCount;
    const yearlyCostWithDiscount = cost * 12 * (1 - discountPercentage);
    const totalYearlyCostWithDiscount = yearlyCostWithDiscount * usersCount;
    return {
      yearlyCost: roundOffNumber(yearlyCost),
      yearlyCostWithDiscount: roundOffNumber(yearlyCostWithDiscount),
      totalYearlyCostWithDiscount: roundOffNumber(totalYearlyCostWithDiscount),
      totalYearlyCost: roundOffNumber(totalYearlyCost)
    };
  };
  const costPerUnit = plans[data.plan.toUpperCase()] || 0;
  const costDetails = calculateCosts(costPerUnit);

  const handleBillingInfo = (e) => {
    setBillingInfo({ ...billingInfo, [e.target.name]: e.target.value });
  };

  const handleConfirmClick = () => {
    handleStripeRedirect(
      btnPlan,
      billingInfo.name !== username ? billingInfo.name : null,
      billingInfo.email !== useremail ? billingInfo.email : null
    );
  };
  console.log({data});
  return (
    <>
      <MantineModal
        open={open}
        onCancel={() => setBillingInfo({ username, useremail }, setOpen(false))}
        title='Billing Information'
        onConfirm={() => handleConfirmClick()}
        loading={isCalculatingUniqueUsersCount}
      >
        <div>
          {channelBasedBilling && (
            <>
              <div className={styles.billingText}>CHANNELS TO ENABLE</div>
              <MultiSelectDropdown
                value={selectedChannels}
                data={dropDownChannelOptions}
                onChange={handleClickInChannelDropdown}
              />
              <div className={styles.note}>
                <span className={styles.note}>
                  Note: Only unique users from the above selected channels will be billed and
                  allowed to play Trivia
                </span>
              </div>
              <br />
              <div className={styles.uniqueUsersText}>
                👥 Total Unique users - {uniqueUsersCount}
              </div>
              <hr className={styles.line} />
            </>
          )}
          <div className={styles.billingText}>BILLING NAME</div>
          <TextField
            className={styles.billingTextField}
            placeholder='Type here'
            name='name'
            value={billingInfo?.name ?? username}
            onChange={handleBillingInfo}
          />

          <div className={styles.billingText}>BILLING EMAIL</div>
          <TextField
            className={styles.billingTextField}
            placeholder='Type here'
            name='email'
            value={billingInfo?.email ?? useremail}
            onChange={handleBillingInfo}
          />
        </div>
      </MantineModal>
      <Section className={`${styles.Plan} ${index === 1 ? styles.larger : ''}`}>
        <aside>
          {index === 1 && (
            <img
              src={popular}
              alt=''
              className={`${styles.popularTag} ${billingIntervalState === 'year' && styles.yearlyStyle
                } ${selectedchannelLength === 0 && channelBasedBilling && styles.noChannelTag}
            `}
            />
          )}
        </aside>
        <div>
          <div
            className={`${styles.planInfo} ${selectedchannelLength === 0 && platform === 'slack' && channelBasedBilling
                ? styles.noChannels
                : styles.withChannels
              }`}
          >
            <div className={styles.userPlan}>{data.plan}</div>
            {selectedchannelLength ? (
              <div className={styles.planDetails}>
                <span>${term === 'year' ? costDetails?.monthlyCost : costPerUnit}</span>/
                {platform === 'slack' ? 'user' : 'Licenses'}
                /month
              </div>
            ) : null}
          </div>
          {selectedchannelLength !== 0 || platform === 'teams' ? (
            billingIntervalState === 'month' ? (
              <div className={styles.someThing}>
                <div className={styles.priceDetails}>
                  <span className={styles.price}>
                    ${term === 'year' ? costDetails?.totalMonthlyCost : costPerUnit * usersCount}
                  </span>
                  /{billingIntervalState}{' '}
                  <span>
                    <PlanCardTooltip
                      title={`${usersCount} users x ${term === 'year' ? costDetails?.monthlyCost : costPerUnit
                        } = ${term === 'year' ? costDetails?.totalMonthlyCost : costPerUnit * usersCount
                        }`}
                    >
                      <InfoIcon />
                    </PlanCardTooltip>
                  </span>
                </div>
                {data.plan !== "Basic" && (<div className={styles.priceDetails} style={{fontSize:'10px'}}>
                  Note: Minimum billing amount is {data.plan === "Pro" ? "$49" : "$29"}.
                </div>)}
              </div>
            ) : (
              <div className={styles.yearlyPlan}>
                <div className={styles.totalCost}>
                  <span className={styles.crossed}>
                    $
                    {term === 'year'
                      ? costDetails?.totalCostWithoutDiscount
                      : costDetails?.totalYearlyCost}
                    /{billingIntervalState}
                  </span>
                  <span className={styles.offPercent}> 20% off</span>
                </div>
                <div className={styles.payingCost}>
                  $
                  {term === 'year'
                    ? costDetails?.totalCostWithDiscount
                    : costDetails?.totalYearlyCostWithDiscount}
                  <span className={styles.year}>/{billingIntervalState}</span>{' '}
                  <span>
                    <PlanCardTooltip
                      title={`(${usersCount} users x $${costPerUnit} x 12) 20% off = $${costDetails?.totalCostWithDiscount}`}
                    >
                      <InfoIcon />
                    </PlanCardTooltip>
                  </span>
                </div>
                {data.plan !== "Basic" && (<div className={styles.priceDetails} style={{fontSize:'10px'}}>
                  Note: Minimum billing amount is {data.plan === "Pro" ? "$479" : "$279"}.
                </div>)}
              </div>
            )
          ) : billingIntervalState === 'month' ? (
            <div className={styles.priceDetails}>
              <span className={styles.price}>
                ${term === 'year' ? costDetails?.monthlyCost : costDetails?.totalYearlyCost}
              </span>
              /{billingIntervalState}{' '}
              <span>
                <PlanCardTooltip
                  title={`${usersCount}  users x ${term === 'year' ? costDetails?.monthlyCost : costPerUnit
                    } = ${term === 'year' ? costDetails?.totalMonthlyCost : costPerUnit * activeUsers
                    } `}
                >
                  <InfoIcon />
                </PlanCardTooltip>
              </span>
               {data.plan !== "Basic" && (<div className={styles.priceDetails} style={{fontSize:'10px'}}>
                  Note: Minimum billing amount is {data.plan === "Pro" ? "$49" : "$29"}.
                </div>)}
            </div>
          ) : (
            <div className={styles.yearlyPlan}>
              <div className={styles.totalCost}>
                <span className={styles.crossed}>
                  $
                  {term === 'year'
                    ? costDetails?.costWithoutDiscount
                    : costDetails?.totalYearlyCost}{' '}
                  /{billingIntervalState}
                </span>
                <span className={styles.offPercent}> 20% off</span>
              </div>
              <div className={styles.payingCostWrapper}>
                <div className={styles.payingCost}>
                  ${term === 'year' ? costPerUnit : costDetails?.totalYearlyCostWithDiscount}/
                  <span className={styles.year}>{billingIntervalState}</span>{' '}
                  <span>
                    <PlanCardTooltip
                      title={`(${usersCount}  users x 12) 20% discount = ${costDetails?.totalYearlyCostWithDiscount}`}
                    >
                      <InfoIcon />
                    </PlanCardTooltip>
                  </span>
                </div>
                 {data.plan !== "Basic" && (<div className={styles.priceDetails} style={{fontSize:'10px'}}>
                  Note: Minimum billing amount is {data.plan === "Pro" ? "$479" : "$279"}.
                </div>)}
              </div>
            </div>
          )}
        </div>
      </Section>
      {freeTrial && data.plan.toUpperCase() === 'BASIC' ? null : data.plan.toUpperCase() ===
        'BASIC' ? (
        <button type='button' className={styles.currentPlanBtn}>
          Current Plan
        </button>
      ) : (
        <button
          type='button'
          onClick={() => handleButtonClick(data.plan.toUpperCase())}
          className={styles.planBtn}
        >
          {' '}
          Choose{' '}
        </button>
      )}
      <ul>
        {data.allFeatures.map((feature, i) => (
          <li key={i}>{feature}</li>
        ))}
      </ul>
    </>
  );
};

export default PlanCardComponent;

PlanCardComponent.propTypes = {
  index: PropTypes.number.isRequired,
  platform: PropTypes.string.isRequired,
  selectedchannelLength: PropTypes.number.isRequired,
  billingIntervalState: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  useremail: PropTypes.string.isRequired,
  channelBasedBilling: PropTypes.number.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  dropDownChannelOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  handleClickInChannelDropdown: PropTypes.func.isRequired,
  btnPlan: PropTypes.string.isRequired,
  uniqueUsersCount: PropTypes.number.isRequired,
  activeUsers: PropTypes.number.isRequired,
  freeTrial: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleStripeRedirect: PropTypes.func.isRequired,
  isCalculatingUniqueUsersCount: PropTypes.bool.isRequired,
  selectedChannels: PropTypes.arrayOf(PropTypes.string).isRequired,
  billingInfo: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string
  }).isRequired,
  setBillingInfo: PropTypes.func.isRequired,
  plans: PropTypes.shape({
    PRO: PropTypes.number,
    STANDARD: PropTypes.number,
    TERM: PropTypes.string
  }).isRequired,
  data: PropTypes.shape({
    plan: PropTypes.string,
    featuresList: PropTypes.arrayOf(PropTypes.string).isRequired,
    allFeatures: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};
